export default __webpack_public_path__ + "static/media/feelingProud.61bf63c3.svg";